import styled from 'styled-components'

export const StripeForm = styled.form`
  width: 100%;
  padding: 15px;
`

export const StripeWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`
